import { Box, Grid } from "@mui/material";

import ModalTrigger from "../Common/ModalTrigger";

import csv3 from "../../Data/MANCP/Pesticides/MANCP-Distribution-of-quantified-results-per-sample.csv";
import csv2 from "../../Data/MANCP/Pesticides/MANCP-Frequency-of-MRL-exceedances-per-pesticide.csv";

import BoxPlotChart from "../Charts/BoxPlotChart";
import FrequencyDataGrid from "./FrequencyDataGrid";
import HistogramChart from "../Charts/HistogramChart";

const PesticideResiduesResults = (props) => {
  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
    >
      <Grid display="flex" justifyContent="center" alignItems="center">
        <Grid
          item
          xs
          sx={{
            paddingLeft: { xs: "24px", sm: "24px", md: "24px" },
            paddingRight: { xs: "24px", sm: "40px", md: "24px" },
            paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
            paddingTop: { xs: "24px", sm: "24px", md: "50px" },
            maxWidth: { md: "450px !important" },
          }}
          className="three-one"
        >
          <Box
            sx={{
              textAlign: { xs: "left", sm: "center", md: "left" },
            }}
          >
            <h3>Results by pesticide</h3>
            <p className="paragraph">
              In 2024, reporting countries submitted to EFSA more than 19,5 million analyses of food commodities tested for pesticide residues. Residue levels were{" "}
              <ModalTrigger
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  borderBottom: "1px dotted",
                }}
                text="quantified"
              />{" "}
              at or above the LOQ in 98,070 analyses, i.e. 0.5% of all reported results.
            </p>

            <p className="paragraph">
              In total,{" "}
              <ModalTrigger
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  borderBottom: "1px dotted",
                }}
                text="reporting countries"
              />{" "}
              analysed up to 738 different pesticides. On average, 261 different pesticide residues were analysed per sample. Countries analysing more than 600 pesticides in the scope of analytical methods were Malta (738 pesticides), Germany (719 pesticides), Luxembourg (692 pesticides), Austria (626 pesticides) and Spain (622 pesticides).
            </p>
            <p className="paragraph">
              Of the 86,449 samples analysed, 41.6% (35,925) contained one or more pesticides in measurable concentrations.{" "}
              <ModalTrigger
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  borderBottom: "1px dotted",
                }}
                text="Multiple residues"
              />{" "}
              were reported in 25.5% (22,051). Up to 36 different pesticides were reported in an individual sample of dried fruit from Vietnam. The sample was deemed non-compliant, and the product lot was destroyed.
            </p>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs width={{ xs: "380px", sm: "100%" }}>
        <Grid item xs p={3} className="three-two">
          <FrequencyDataGrid
            title="Frequency of MRL exceedances per pesticide"
            csv={csv2}
          />
        </Grid>

        <Grid item xs p={3}>
          <BoxPlotChart
            title="Distribution of number of results per sample"
            csv={csv3}
          />
          <HistogramChart csv={csv3} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PesticideResiduesResults;
